module.exports = __webpack_public_path__ + "static/media/unh.7fe2d98c.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/other/unh.jpg
// module id = 450
// module chunks = 0